export default __webpack_public_path__ + "static/media/giving-yourAll.5ce2592e.webp";